
import { defineComponent, computed } from 'vue';
import Attendance from '@/components/calendar/Attendance.vue';
import { calendarStore } from '@/store/calendar-store';
import { domainStore } from '@/store/domain-store';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { EventAttributeInterface, EventInterface } from '@/models/calendar.model';

export default defineComponent({
  name: 'EventDetail',
  props: {
    privacyPageUrl: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    const eventAttributes = computed((): EventAttributeInterface | undefined => {
      return calendarStore.getState().singleEvent.eventAttributes;
    });
    const event = computed((): EventInterface => {
      return calendarStore.getState().singleEvent;
    });
    const eventAssignedAttributes = computed(() => {
      // Für Anmeldung
      return event.value.assigned_attributes;
    });
    function mapLink() {
      const linkedMap = calendarStore.getState().calendarConfig.linked_map;
      if (linkedMap == 'google_maps') {
        return (window.location.href = 'https://www.google.com/maps/?q=' + encodeURI(event.value.place));
      } else if (linkedMap == 'open_street_map') {
        return (window.location.href = 'https://www.openstreetmap.org/search?query=' + encodeURI(event.value.place));
      } else return null;
    }

    return {
      domainStore,
      calendarState: calendarStore.getState(),
      event,
      eventAttributes,
      eventAssignedAttributes,
      mapLink,
    };
  },
  components: {
    WdwDynbox,
    Attendance,
  },
});
